import React, { useState } from 'react';
import { useAuth } from '../auth/useAuth';

export default function TermsModal() {
  const { user, loading, termsAccepted, acceptTerms } = useAuth();
  const [accepting, setAccepting] = useState(false);
  const [error,     setError]     = useState('');

  // Zeige Modal nur wenn: eingeloggt, fertig geladen, noch nicht akzeptiert
  if (loading || !user || termsAccepted) return null;

  async function handleAccept() {
    setAccepting(true);
    setError('');
    try {
      await acceptTerms();
    } catch {
      setError('Fehler beim Speichern. Bitte versuche es erneut.');
      setAccepting(false);
    }
  }

  return (
    <div style={{
      position:        'fixed',
      inset:           0,
      zIndex:          9999,
      display:         'flex',
      alignItems:      'center',
      justifyContent:  'center',
      padding:         '1rem',
      background:      'rgba(3, 6, 23, 0.88)',
      backdropFilter:  'blur(8px)',
    }}>
      <div style={{
        maxWidth:        '520px',
        width:           '100%',
        background:      'rgba(8, 15, 42, 0.95)',
        border:          '1px solid rgba(0, 217, 255, 0.25)',
        borderRadius:    '20px',
        padding:         '2rem',
        boxShadow:       '0 24px 64px rgba(0, 0, 0, 0.6)',
      }}>
        {/* Titel */}
        <div style={{ marginBottom: '1.5rem' }}>
          <h2 style={{
            fontSize:    '1.2rem',
            fontWeight:  700,
            color:       '#fff',
            marginBottom: '0.35rem',
          }}>
            Kurzer Hinweis vor der Nutzung
          </h2>
          <p style={{ fontSize: '0.85rem', color: 'rgba(255,255,255,0.5)' }}>
            Bitte lies die folgenden Punkte, bevor du die Plattform verwendest.
          </p>
        </div>

        {/* Hinweise */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem', marginBottom: '1.75rem' }}>

          {/* OpenAI */}
          <div style={{
            background:   'rgba(0, 217, 255, 0.06)',
            border:       '1px solid rgba(0, 217, 255, 0.15)',
            borderRadius: '12px',
            padding:      '1rem 1.1rem',
          }}>
            <p style={{ fontWeight: 600, fontSize: '0.9rem', color: '#fff', marginBottom: '0.35rem' }}>
              🤖 KI-Verarbeitung durch OpenAI
            </p>
            <p style={{ fontSize: '0.82rem', color: 'rgba(255,255,255,0.65)', lineHeight: 1.5 }}>
              Texte, die du in die Werkzeuge eingibst (z. B. Meeting-Transkripte, Prozessbeschreibungen), werden zur Verarbeitung an die <strong style={{ color: '#fff' }}>OpenAI API</strong> übermittelt. Gib keine streng vertraulichen Unternehmensgeheimnisse ein, wenn deren externe Übermittlung nicht erlaubt ist.
            </p>
          </div>

          {/* Haftung */}
          <div style={{
            background:   'rgba(250, 204, 21, 0.05)',
            border:       '1px solid rgba(250, 204, 21, 0.18)',
            borderRadius: '12px',
            padding:      '1rem 1.1rem',
          }}>
            <p style={{ fontWeight: 600, fontSize: '0.9rem', color: '#fff', marginBottom: '0.35rem' }}>
              ⚠️ Keine verbindliche Beratung
            </p>
            <p style={{ fontSize: '0.82rem', color: 'rgba(255,255,255,0.65)', lineHeight: 1.5 }}>
              Die KI-Ergebnisse sind <strong style={{ color: '#fff' }}>Unterstützung und Orientierung</strong>, keine rechtlich, medizinisch oder fachlich verbindliche Beratung. Prüfe Ergebnisse eigenverantwortlich bevor du sie verwendest.
            </p>
          </div>

          {/* Datenschutz */}
          <div style={{
            background:   'rgba(124, 60, 255, 0.06)',
            border:       '1px solid rgba(124, 60, 255, 0.2)',
            borderRadius: '12px',
            padding:      '1rem 1.1rem',
          }}>
            <p style={{ fontWeight: 600, fontSize: '0.9rem', color: '#fff', marginBottom: '0.35rem' }}>
              🔒 Datenschutz
            </p>
            <p style={{ fontSize: '0.82rem', color: 'rgba(255,255,255,0.65)', lineHeight: 1.5 }}>
              Deine Daten (Nutzungsaktivitäten, gespeicherte Dokumente) werden sicher auf EU-Servern (Frankfurt) gespeichert. Aktivitätsdaten werden nach 180 Tagen automatisch gelöscht.{' '}
              <a
                href="/datenschutz"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: '#a78bfa', textDecoration: 'underline' }}
              >
                Vollständige Datenschutzerklärung →
              </a>
            </p>
          </div>
        </div>

        {/* Fehler */}
        {error && (
          <p style={{ color: '#f87171', fontSize: '0.82rem', marginBottom: '0.75rem' }}>{error}</p>
        )}

        {/* Button */}
        <button
          onClick={handleAccept}
          disabled={accepting}
          style={{
            width:        '100%',
            padding:      '0.85rem',
            background:   accepting ? 'rgba(0,217,255,0.3)' : 'linear-gradient(90deg, #1877FF 0%, #00D9FF 100%)',
            border:       'none',
            borderRadius: '10px',
            color:        '#fff',
            fontWeight:   700,
            fontSize:     '0.95rem',
            fontFamily:   'inherit',
            cursor:       accepting ? 'not-allowed' : 'pointer',
            transition:   'opacity 0.15s',
          }}
        >
          {accepting ? 'Wird gespeichert…' : 'Verstanden – Plattform nutzen'}
        </button>

        <p style={{ textAlign: 'center', fontSize: '0.74rem', color: 'rgba(255,255,255,0.3)', marginTop: '0.75rem' }}>
          Mit dem Klick bestätigst du, dass du diese Hinweise zur Kenntnis genommen hast.
        </p>
      </div>
    </div>
  );
}
